import {NgModule} from '@angular/core';
import {ImagesDialogComponent} from './images-dialog.component';
import {AppDialogModule} from '@components/dialog/modules/app-dialog.module';
import { CommonModule } from '@angular/common';
import {GalleryModule} from 'ng-gallery';
import {LightboxModule} from 'ng-gallery/lightbox';
import {ButtonModule} from "@components/button/modules/button.module";

@NgModule({
    declarations: [ImagesDialogComponent],
    imports: [
        CommonModule,
        AppDialogModule,
        GalleryModule,
        LightboxModule,
        ButtonModule
    ]
})
export class ImagesDialogModule {
}
